import React from "react"
import {
  partenairesContainer,
  listPartenairesContainer,
  partenairesTitle,
  partenaireDescription,
  editButtonTitle,
} from "./partenaires.module.scss"
import PropTypes from "prop-types"
import { Title } from "./partenaires-styled"
import ContentTransformer from "../../Transformers/content-transformer"
import PartenaireItem from "./PartenaireItem/partenaire-item"
import { usePartenaires } from "./partenaires-query"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"

//-----------------------Parent component---------------------------//

const ListPartenaires = () => {
  const data = usePartenaires()
  const partenaireItem = data.allDirectLinkEntityDirectLinkEntity.edges
  if (partenaireItem.length > 0) {
    return (
      <div className={listPartenairesContainer}>
        <Title className={partenairesTitle}>
          <EditButton
            addedClass={editButtonTitle}
            link={
              "/taxonomy/term/" +
              data.taxonomyTermTypeDeLienDirect.drupal_internal__tid +
              "/edit"
            }
          />
          {data.taxonomyTermTypeDeLienDirect?.field_label || "Partenaires"}
        </Title>
        {data.taxonomyTermTypeDeLienDirect.description && (
          <div className={partenaireDescription}>
            <ContentTransformer
              content={data.taxonomyTermTypeDeLienDirect.description.processed}
            ></ContentTransformer>
          </div>
        )}
        <ul className={partenairesContainer}>
          <RenderPartenaires partenairesData={data} />
        </ul>
      </div>
    )
  }
  return null
}
//-----------------------Parent component---------------------------//

//-----------------------Child component---------------------------//

const RenderPartenaires = ({ partenairesData }) => {
  return partenairesData.allDirectLinkEntityDirectLinkEntity.edges.map(
    ({ node }) => {
      return <PartenaireItem key={node.drupal_id} partenaire={node} />
    }
  )
}
//-----------------------Child component---------------------------//

//-----------------------Prop-Types---------------------------//

RenderPartenaires.propTypes = {
  partenairesData: PropTypes.object.isRequired,
}

//-----------------------Prop-Types---------------------------//

export default ListPartenaires
